var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"overflow-auto align-items-center position-relative display-flex border-bottom border-white-darker-4 margin-bottom-big"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }